'use strict';

var _a, _b;

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.TREE_SIZE_PARAMS = exports.TABLE_SIZE_PARAMS = void 0;

var components_1 = require('./components');

exports.TABLE_SIZE_PARAMS =
  ((_a = {}),
  (_a[components_1.TABLE_SIZES.medium] = {
    cellHorizontalPadding: 12,
    cellVerticalPadding: 10,
    cellTypographyVariant: components_1.TYPOGRAPHY_VARIANTS.bodyM,
    headTypographyVariant: components_1.TYPOGRAPHY_VARIANTS.accentS,
    checkboxSize: components_1.CHECKBOX_SIZES.medium,
    iconSize: 20,
    offsetSize: 40,
  }),
  (_a[components_1.TABLE_SIZES.small] = {
    cellHorizontalPadding: 8,
    cellVerticalPadding: 4,
    cellTypographyVariant: components_1.TYPOGRAPHY_VARIANTS.caption,
    headTypographyVariant: components_1.TYPOGRAPHY_VARIANTS.accentXS,
    checkboxSize: components_1.CHECKBOX_SIZES.small,
    iconSize: 16,
    offsetSize: 40,
  }),
  _a);
exports.TREE_SIZE_PARAMS =
  ((_b = {}),
  (_b[components_1.TREE_SIZES.medium] = {
    verticalPadding: 8,
    horizontalPadding: 4,
    innerPadding: 8,
    typographyVariant: components_1.TYPOGRAPHY_VARIANTS.bodyM,
    checkboxSize: components_1.CHECKBOX_SIZES.medium,
    iconSize: 24,
  }),
  (_b[components_1.TREE_SIZES.small] = {
    verticalPadding: 4,
    horizontalPadding: 2,
    innerPadding: 8,
    typographyVariant: components_1.TYPOGRAPHY_VARIANTS.caption,
    checkboxSize: components_1.CHECKBOX_SIZES.small,
    iconSize: 16,
  }),
  _b);
